import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Row, Tab, Tabs } from 'react-bootstrap';
import CentralizedSpinner from 'components/CentralizedSpinner';
import useTabData from 'hooks/Windx/About/useTabData';
import AboutSection from 'components/Windx/About/AboutSection';
import useIsMobile from 'utils/hooks/useIsMobile';

import AboutMobile from './Mobile';
import './index.scss';

export default function About() {
  const isMobile = useIsMobile();
  const { instructionTabs, isLoading } = useTabData();
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab');
  const [key, setKey] = useState<string | null>(initialTab);

  if (isMobile) return <AboutMobile />;

  return (
    <>
      <Row>
        <h1>SOBRE</h1>
      </Row>
      {isLoading && <CentralizedSpinner />}
      {instructionTabs?.length && (
        <Row className="windx-about-tab-container">
          <Tabs
            activeKey={key || String(instructionTabs[0].id)}
            onSelect={(k) => setKey(k)}
            transition={false}
            id="windx-about-tabs"
            className="tabbed-page gap-1 title-semi-bold"
          >
            {instructionTabs.map((tab) => (
              <Tab
                key={tab.id}
                eventKey={String(tab.id)}
                title={tab.title.toUpperCase()}
                className="p-4"
              >
                <AboutSection tab={tab} activeKey={key || String(instructionTabs[0].id)} />
              </Tab>
            ))}
          </Tabs>
        </Row>
      )}
    </>
  );
}
